import { Directive, ElementRef, OnChanges, inject, input } from '@angular/core';
import { Site } from '../shared/service/site.service';

/**
 * 首页导航开关
 *
 * 根据站点配置，是否在首页显示导航
 * @version 1.0
 * @since 1.0
 */
@Directive({
  selector: 'fl-nav-header',
  standalone: false,
})
export class NavHeaderDirective implements OnChanges {
  readonly site = input<Site>(undefined);

  private el = inject(ElementRef);

  ngOnChanges() {
    /*const hidNav = window.location.pathname === "/" && this.site && this.site.config && this.site.config.hideNavOnHome;*/
    const site = this.site();
    const hidNav = window.location.pathname === '/' && site && site.config;
    this.el.nativeElement.style.display = hidNav ? 'none' : 'block';
  }
}
